import { useNavigate } from "react-router-dom"
import { Button } from "../../common/components/controls/button"
import { Icon } from "../../common/components/icons"
import { textChooser } from "../../common/util/textChooser"
import styled from "styled-components";

const PageWrapper = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    height: 80vh;
    gap: 45px;
`

export const SuccessSubscription = () => {

    const navigate = useNavigate();
    
    return (
        <div className="page -success">
            <PageWrapper>
                <div className="error-icon">
                    <Icon type="successCheck"/>
                </div>
                
                <div style={{textAlign: "center"}}>
                    <h1 className="heading sizeXXl">
                        {textChooser("txt195")}
                    </h1>
                    <p className="text sizeMd cleaned">
                        {textChooser("txt191")}
                    </p>
                </div>

                <Button onClick={() => navigate("/")} primary>
                    {textChooser("txt220")}
                </Button>
            </PageWrapper>
        </div>
    )
}